import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

const TOKEN_KEY = 'admin_token';
const CUSTOMER_TOKEN_KEY = 'customer_token';

api.interceptors.request.use((config) => {
  const url = config.url || '';
  const t = localStorage.getItem(TOKEN_KEY);
  if (t && url.startsWith('/admin')) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  const ct = localStorage.getItem(CUSTOMER_TOKEN_KEY);
  const isCustomerAuthed = url.startsWith('/auth/') && !url.startsWith('/auth/login') && !url.startsWith('/auth/register') && !url.startsWith('/auth/send-otp') && !url.startsWith('/auth/forgot-password') && !url.startsWith('/auth/reset-password');
  if (ct && (isCustomerAuthed || url.startsWith('/orders') || url.startsWith('/razorpay'))) {
    config.headers.Authorization = `Bearer ${ct}`;
  }
  return config;
});

export const customerAuth = {
  sendOtp: async (email, purpose = 'register') => (await api.post('/auth/send-otp', { email, purpose })).data,
  register: async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    localStorage.setItem(CUSTOMER_TOKEN_KEY, data.token);
    return data.customer;
  },
  login: async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem(CUSTOMER_TOKEN_KEY, data.token);
    return data.customer;
  },
  verifyEmailSend: async () => (await api.post('/auth/verify-email/send')).data,
  verifyEmailConfirm: async (otp) => (await api.post('/auth/verify-email/confirm', { otp })).data,
  me: async () => (await api.get('/auth/me')).data,
  updateMe: async (payload) => (await api.put('/auth/me', payload)).data,
  orders: async () => (await api.get('/auth/orders')).data,
  forgotPassword: async (email) => (await api.post('/auth/forgot-password', { email, reset_base: window.location.origin })).data,
  resetPassword: async (token, password) => (await api.post('/auth/reset-password', { token, password })).data,
  logout: () => localStorage.removeItem(CUSTOMER_TOKEN_KEY),
  isLoggedIn: () => !!localStorage.getItem(CUSTOMER_TOKEN_KEY),
};

export const customers = {
  list: async () => (await api.get('/admin/customers')).data,
};

export const razorpay = {
  createOrder: async (amount, order_id) => (await api.post('/razorpay/create-order', { amount, order_id })).data,
  verify: async (payload) => (await api.post('/razorpay/verify', payload)).data,
};

export const auth = {
  login: async (password) => {
    const { data } = await api.post('/admin/login', { password });
    localStorage.setItem(TOKEN_KEY, data.token);
    return data.token;
  },
  logout: () => localStorage.removeItem(TOKEN_KEY),
  isLoggedIn: () => !!localStorage.getItem(TOKEN_KEY),
  verify: async () => {
    try {
      await api.get('/admin/verify');
      return true;
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      return false;
    }
  },
};

export const site = {
  getAll: async () => (await api.get('/site')).data,
};

export const orders = {
  create: async (data) => (await api.post('/orders', data)).data,
  updatePublic: async (id, data) => (await api.patch(`/orders/${id}`, data)).data,
  list: async (status) => (await api.get('/admin/orders', { params: status ? { status } : {} })).data,
  setStatus: async (id, status, tracking_number) => (await api.put(`/admin/orders/${id}/status`, tracking_number !== undefined ? { status, tracking_number } : { status })).data,
  remove: async (id) => (await api.delete(`/admin/orders/${id}`)).data,
};

const crud = (name) => ({
  create: async (data) => (await api.post(`/admin/${name}`, data)).data,
  update: async (id, data) => (await api.put(`/admin/${name}/${id}`, data)).data,
  remove: async (id) => (await api.delete(`/admin/${name}/${id}`)).data,
});

export const branding = {
  update: async (data) => (await api.put('/admin/branding', data)).data,
};
export const pageSettings = {
  update: async (data) => (await api.put('/admin/page_settings', data)).data,
};
export const navLinks = crud('nav_links');
export const banners = crud('banners');
export const categories = crud('categories');
export const products = crud('products');
export const features = crud('features');
export const stats = crud('stats');
export const faqs = crud('faqs');
export const pricing = crud('pricing');
export const sizeCharts = crud('size_charts');

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post('/admin/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.url;
};

export const seed = async () => (await api.post('/admin/seed')).data;

export default api;
